import { useState, useEffect } from 'react'
const isBrowser = typeof window !== 'undefined'

export function usePersistedState(key, initialValue = {}) {
  const [value, setValue] = useState(() => {
    if (!isBrowser) {
      return initialValue
    }
    const persistedValue = window.localStorage.getItem(key)
    return persistedValue !== null && persistedValue !== 'undefined'
      ? JSON.parse(persistedValue)
      : initialValue
  })

  useEffect(() => {
    window.localStorage.setItem(key, JSON.stringify(value))
  }, [key, value])

  function unsetValue() {
    setValue({})
  }

  return [value, setValue, unsetValue]
}

// Source: https://usehooks.com/useOnClickOutside/
export function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }
      handler(event)
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
}
